(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  console.log("Hello");
  const getActiveSales = async () => {
    try {
      const res = await fetch("/apps/explorator/saleBanners");
      const slideshowData = await res.json();
      return slideshowData.data;
    } catch(err) {
      console.log(err);
    }
  }

  const formatSlide = (imageURL, titleString) => {
    const container = document.createElement("div");
    container.style.height = "500px";
    container.style.width = "100%";
    container.style.position = "absolute";
    container.style.backgroundImage = "url('" + imageURL + "')";
    container.style.backgroundImageRepeat = "no-repeat";
    container.style.backgroundPosition = "center";
    container.style.display = "flex";
    container.style.justifyContent = "center";
    
    const title = document.createElement("h1");
    title.class = "headline";
    title.style.height = "fit-content";
    title.style.margin = "auto";
    title.style.color = 'white';
    title.style.textShadow = "2px 4px 3px rgba(0,0,0,0.3)";
    title.innerHTML = titleString;
    container.appendChild(title);
    return container;
  }

  const main = async () => {
    try {
      const activeSales = await getActiveSales();
      activeSales.forEach(sale => {
        const node = formatSlide(sale.bannerImage, sale.name);
        $('.js-homepage-slideshow').flickity('append', node);
      });
    } catch(err) {
      console.error(err);
    }
  }

  main();

  } catch(e) { console.error(e); }
})();

})();
